module.exports = require("./../../_gen/starling/rendering/VertexDataAttribute");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/rendering/VertexDataAttribute.js
// module id = 219
// module chunks = 0